export * from './medicalDocument.model';
export * from './medicalDocument.service';
export * from './medicalDocument.slice';
